import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';
import { type CharacterSet } from '@tari-labs/emojis-wasm-default';

import { type EmojiCopy } from '@pkg/types';

import { type RootState } from '../reducers';
import {
    ADD_EMOJI,
    ADD_PRE_EMOJIS,
    COPY_EMOJI,
    type currentIndexInteractionResponse,
    type Emoji,
    type EmojiListStatus,
    INIT_SELECT_INDEX,
    NEXT_SEARCH_EMOJI,
    PASTE_EMOJI,
    PREV_SEARCH_EMOJI,
    REMOVE_EMOJI,
    SET_EMOJI_LIST,
    SET_INPUT_FOCUSED,
    SET_INPUT_VALUE,
    SET_RHYTHM_SCORE,
    SET_RHYTHM_SCORE_COPY,
    SET_SEARCH_EMOJI,
    SET_WASM_FILTER,
    UPDATE_EMOJIS,
    UPDATE_SEARCH,
    UPDATE_STATUS,
} from '../types/picker';

export const addEmoji = (emoji: Emoji) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: ADD_EMOJI,
        payload: emoji,
    });
};

export const addPreEmojis = (emojis: Emoji[]) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: ADD_PRE_EMOJIS,
        payload: emojis,
    });
};

export const removeEmoji = (removalIndex: number) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: REMOVE_EMOJI,
        payload: removalIndex,
    });
};

export const pasteEmoji = () => async (dispatch: ThunkDispatch<RootState, void, Action>) => {
    const clipboard = await navigator.clipboard.readText();
    dispatch({
        type: PASTE_EMOJI,
        payload: clipboard,
    });
};

export const copyEmoji = () => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: COPY_EMOJI,
    });
};

export const setSearchEmoji =
    (newIndex: currentIndexInteractionResponse) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
        dispatch({
            type: SET_SEARCH_EMOJI,
            payload: newIndex,
        });
    };

export const prevSearchEmoji = () => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: PREV_SEARCH_EMOJI,
    });
};

export const nextSearchEmoji = () => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: NEXT_SEARCH_EMOJI,
    });
};

export const initSelectIndex = () => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: INIT_SELECT_INDEX,
    });
};

export const setInputValue = (inputValue: string) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_INPUT_VALUE,
        payload: inputValue,
    });
};

export const setInputFocus = (isFocused: boolean) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_INPUT_FOCUSED,
        payload: isFocused,
    });
};

export const updateSearch = (inputValue: string) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: UPDATE_SEARCH,
        payload: inputValue,
    });
};

export const updateStatus = (status: EmojiListStatus) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: UPDATE_STATUS,
        payload: status,
    });
};

export const updateEmojis = (emojis: Array<Emoji>) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: UPDATE_EMOJIS,
        payload: emojis,
    });
};

export const setEmojiFilter = (filter: CharacterSet) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_WASM_FILTER,
        payload: filter,
    });
};

export const setEmojiList = (emojis: Array<Emoji>) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_EMOJI_LIST,
        payload: emojis,
    });
};

export const setRhythmScore = (score: number) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_RHYTHM_SCORE,
        payload: score,
    });
};

export const setRhythmScoreCopy = (copy: EmojiCopy) => (dispatch: ThunkDispatch<RootState, void, Action>) => {
    dispatch({
        type: SET_RHYTHM_SCORE_COPY,
        payload: copy,
    });
};
